import React from 'react'
import PropTypes from 'prop-types'
import './style.css'

import { getMonthAppointmentsSortedByDate } from 'lib/helper'

import { Grid, Row, Col } from 'react-flexbox-grid'
import AppointmentCard from 'components/AppointmentCard'

const AppointmentCardList = ({ appointments, onAppointmentStart, onAppointmentComplete, onAppointmentCancel }) => {

  const appointmentsByDates = getMonthAppointmentsSortedByDate(appointments)

  return (
    <div className="AppointmentCardList">

      {appointmentsByDates.map((ad, i) => (
        <AppointmentCardListContainer key={i}
          date={ad.label}
          appointments={ad.appointments}
          onAppointmentStart={onAppointmentStart}
          onAppointmentComplete={onAppointmentComplete}
          onAppointmentCancel={onAppointmentCancel}
          />
      ))}

    </div>
  )
}
AppointmentCardList.propTypes = {
  appointments: PropTypes.array.isRequired,
  onAppointmentStart: PropTypes.func.isRequired,
  onAppointmentComplete: PropTypes.func.isRequired,
  onAppointmentCancel: PropTypes.func.isRequired,
}

const AppointmentCardListContainer = ({ date, appointments, onAppointmentStart, onAppointmentComplete, onAppointmentCancel }) => (
  <div className="AppointmentCardList_Container">
    <h4>{date}</h4>
    <Grid fluid>
      <Row>
        {appointments.map(a => (
          <Col xs={12} sm={6} md={4} key={a.appointmentId}>
            <AppointmentCard
              appointment={a}
              onStart={onAppointmentStart}
              onComplete={onAppointmentComplete}
              onCancel={onAppointmentCancel}
              />
          </Col>
        ))}
      </Row>
    </Grid>
  </div>
)

export default AppointmentCardList



// WEBPACK FOOTER //
// ./src/components/AppointmentCardList/index.js